import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { paidActions, paidSelector } from '$store/paid/index';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { scrollToBottom } from '$utils';
import { LoadChatMedia, LoadMorePaidMessagesAction } from '$store/paid/interface';
import router from '$navigation/router';

function* loadPaidMessagesWorker() {
  try {
    const { params } = yield call(router.getState);
    const data = yield call(Api.get, `/purchases?startFrom=0&peerId=${+params.peer_id}`);
    const { messages } = yield select(paidSelector);

    yield put(paidActions.setPaidMessages(data));
    if (!messages.length) {
      yield call(scrollToBottom, 'purchased_history');
    }
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* loadMorePaidMessagesWorker(action: LoadMorePaidMessagesAction) {
  try {
    const { params } = yield call(router.getState);
    const data = yield call(
      Api.get,
      `/purchases?startFrom=${action.payload}&peerId=${+params.peer_id}`,
    );

    yield put(paidActions.setMorePaidMessages(data));
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* loadChatMedia(action: LoadChatMedia) {
  try {
    const { payload } = action;
    const { params } = yield call(router.getState);
    const data = yield call(
      Api.get,
      `/purchases/media?userId=${params.peerId}&desc=${payload}`,
    );

    yield put(paidActions.setMediaMessages(data));
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

export function* paidSaga() {
  yield all([
    takeLatest(paidActions.loadPaidMessages, loadPaidMessagesWorker),
    takeLatest(paidActions.loadMorePaidMessages, loadMorePaidMessagesWorker),
    takeLatest(paidActions.loadMediaMessages, loadChatMedia),
  ]);
}
